<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="6"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
						</m-search-item>
						<m-search-item label="创建时间">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_sales_handover_accept')" prepend-icon="tf-accept" color="main" @click="batchAcceptHandover">批量接驳</c-button>
					<c-button v-if="auth('b_sales_handover_reject')" prepend-icon="tf-reject" color="red" :hollow="true" @click="batchRejectHandover">批量驳回</c-button>
					<c-button v-if="auth('b_sales_handover_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #batchOperate>
					<c-button v-if="auth('b_sales_handover_accept')" prepend-icon="tf-accept" color="main" @click="batchAcceptHandover">批量接驳</c-button>
					<c-button v-if="auth('b_sales_handover_reject')" prepend-icon="tf-reject" color="red" :hollow="true" @click="batchRejectHandover">批量驳回</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_sales_handover_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #produce_info="{data}">
					<m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
				</template>


				<template #purchase_price="{data}">
					{{formatPrice(data.purchase_price)}}
				</template>
                <template #cost_price="{data}">
                    {{formatPrice(data.cost_price)}}
                </template>
				<template #in_stock_days="{data}">
					{{formatDay(data.in_stock_days)}}
				</template>

				<template #product_state="{data}">
					<c-state dict="productStateDic" :value="data.product_state"></c-state>
				</template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #handover_state_show="{data}">
					<c-state dict="ACCEPT_REJECT_STATE" :value="data.handover_state_show"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="200"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_sales_handover_accept')" :disabled="data.handover_state != 1" icon="tf-accept" @click="acceptHandover(data)">接驳</c-table-button>
						<c-table-button v-if="auth('b_sales_handover_reject')" :disabled="data.handover_state != 1" icon="tf-reject" @click="rejectHandover(data)">驳回</c-table-button>
                        <c-table-button v-if="auth('b_sales_handover_reject') && data.buttons?.cancel_reject?.visible" icon="tf-revoke" @click="cancelReject(data)">撤销</c-table-button>
                    </template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
    import handoverReject from '@/mixins/handover_reject'

	export default {
        mixins: [handoverReject],
        handoverModuleType: 3,

		methods: {
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price);
			},

			/*********格式化天数**********/
			formatDay(day) {
				if (day === null || day === undefined || day === '') return '-';
				return parseInt(day) + '天';
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.color_name) parts.push(data.color_name);
				if (data.memory_name) parts.push(data.memory_name);
				return parts.join(' ') || '-';
			},

			/*********批量接驳************/
			batchAcceptHandover() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				if (!selected.length) {
					// 无选中，打开扫码弹框
					this.globalDialog('handoverDialog', {props: {mode: 'accept', type: 3}}, () => {
						this.$refs.view.update();
					});
					return;
				}
				// 有选中，校验状态
				var validList = selected.filter(item => item.handover_state == 1);
				if (!validList.length) {
					this.$message({message: '所选记录均已被处理，无法接驳', type: 'warn'});
					return;
				}
				var ids = validList.map(item => item.id);
				this.$confirm({
					message: '确认接驳所选的' + ids.length + '条记录吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/handover/batch/accept',
							data: {ids: ids},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********批量驳回************/
			batchRejectHandover() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				var validList = selected.filter(item => item.handover_state == 1);
				if (selected.length && !validList.length) {
					this.$message({message: '所选记录均已被处理，无法驳回', type: 'warn'});
					return;
				}
				this.globalDialog('handoverDialog', {props: {mode: 'reject', type: 3, initialList: validList}}, () => {
					this.$refs.view.update();
				});
			},

			/*********单条接受************/
			acceptHandover(data) {
				this.$confirm({
					message: '确认接受该接驳记录？',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/handover/accept',
							data: {id: data.id},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********单条驳回************/
			rejectHandover(data) {
				this.globalDialog('handoverDialog', {props: {mode: 'reject', type: 3, initialList: [data]}}, () => {
					this.$refs.view.update();
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
